import PropTypes from "prop-types";
import { List, Tooltip, IconButton, Typography, Switch } from "@mui/material";
import makeStyles from "@mui/styles/makeStyles";
import FlexCol from "./FlexCol";
import FlexRow from "./FlexRow";

const useStyles = makeStyles(theme => ({
  menu: {
    display: "flex",
    padding: 0,
    margin: 0,
  },
  divider: {
    borderLeft: "1px solid lightgray",
    marginLeft: theme.spacing(0.5),
    marginRight: theme.spacing(0.5),
  },
  buttonPressed: {
    background: theme.palette.grey[300],
    borderRadius: 4,
  },
  square: {
    borderRadius: 4,
    minWidth: 40,
  },
}));

function IconMenuHoriz({ items }) {
  const classes = useStyles();
  return (
    <List className={classes.menu}>
      <FlexRow itemSpacing={1}>
        {items.map(
          (
            {
              onClick,
              labelAbove,
              hoverText = "",
              icon = null,
              isSwitch = null,
              switchChecked = null,
              visible = true,
              buttonPressed,
              disabled,
              divider,
            },
            i
          ) =>
            !visible ? null : divider ? (
              <div key={i} className={classes.divider} />
            ) : (
              <Tooltip key={i} title={hoverText}>
                {isSwitch ? (
                  <FlexCol fullHeight vAlign="top" hAlign="center" style={{ padding: "2px" }}>
                    <Typography variant="caption" align="center">
                      {labelAbove}
                    </Typography>
                    <Switch
                      checked={switchChecked}
                      onChange={onClick}
                      size="small"
                      style={{ height: "27px" }}
                    />
                  </FlexCol>
                ) : (
                  <span>
                    <IconButton
                      className={buttonPressed ? classes.buttonPressed : classes.square}
                      size="small"
                      onClick={onClick}
                      disabled={disabled}
                      style={{ padding: "0px" }}
                    >
                      <FlexCol fullHeight vAlign="top" hAlign="center" style={{ padding: "2px" }}>
                        <Typography variant="caption" align="center">
                          {labelAbove}
                        </Typography>
                        {icon}
                      </FlexCol>
                    </IconButton>
                  </span>
                )}
              </Tooltip>
            )
        )}
      </FlexRow>
    </List>
  );
}

IconMenuHoriz.propTypes = {
  items: PropTypes.arrayOf(
    // Allows the item object or false (to skip item)
    PropTypes.oneOfType([
      PropTypes.shape({
        onClick: PropTypes.func,
        labelAbove: PropTypes.string,
        hoverText: PropTypes.string,
        icon: PropTypes.object,
        isSwitch: PropTypes.bool,
        switchChecked: PropTypes.bool,
        visible: PropTypes.bool,
        buttonPressed: PropTypes.bool,
        disabled: PropTypes.bool,
        divider: PropTypes.bool,
      }),
      PropTypes.oneOf([false]),
    ])
  ),
};

export default IconMenuHoriz;
